module.exports = __webpack_public_path__ + "static/media/CeraPro-Medium.369f911c.eot";